import { handleActions } from 'redux-actions';

const initialState = {
  isLoading: false,
  error: null,
  setup: {
    secret: null,
    qrCode: null,
    backupCodes: [],
  },
  status: {
    enabled: false,
    enabledAt: null,
  },
  backupCodes: [],
};

const TwoFactorReducer = handleActions(
  {
    // Setup actions
    TWO_FACTOR_SETUP_REQUEST: state => ({
      ...state,
      isLoading: true,
      error: null,
    }),
    TWO_FACTOR_SETUP_SUCCESS: (state, action) => ({
      ...state,
      isLoading: false,
      error: null,
      setup: {
        secret: action.payload.secret,
        qrCode: action.payload.qrCode,
        backupCodes: action.payload.backupCodes || [],
      },
    }),
    TWO_FACTOR_SETUP_ERROR: (state, action) => ({
      ...state,
      isLoading: false,
      error: action.payload,
    }),

    // Enable actions
    TWO_FACTOR_ENABLE_REQUEST: state => ({
      ...state,
      isLoading: true,
      error: null,
    }),
    TWO_FACTOR_ENABLE_SUCCESS: (state, _action) => ({
      ...state,
      isLoading: false,
      error: null,
      status: {
        enabled: true,
        enabledAt: new Date().toISOString(),
      },
      setup: {
        secret: null,
        qrCode: null,
        backupCodes: state.setup.backupCodes, // Keep backup codes for display
      },
    }),
    TWO_FACTOR_ENABLE_ERROR: (state, action) => ({
      ...state,
      isLoading: false,
      error: action.payload,
    }),

    // Disable actions
    TWO_FACTOR_DISABLE_REQUEST: state => ({
      ...state,
      isLoading: true,
      error: null,
    }),
    TWO_FACTOR_DISABLE_SUCCESS: state => ({
      ...state,
      isLoading: false,
      error: null,
      status: {
        enabled: false,
        enabledAt: null,
      },
      setup: {
        secret: null,
        qrCode: null,
        backupCodes: [],
      },
      backupCodes: [],
    }),
    TWO_FACTOR_DISABLE_ERROR: (state, action) => ({
      ...state,
      isLoading: false,
      error: action.payload,
    }),

    // Status actions
    TWO_FACTOR_STATUS_REQUEST: state => ({
      ...state,
      isLoading: true,
      error: null,
    }),
    TWO_FACTOR_STATUS_SUCCESS: (state, action) => ({
      ...state,
      isLoading: false,
      error: null,
      status: {
        enabled: action.payload.enabled,
        enabledAt: action.payload.enabledAt,
      },
    }),
    TWO_FACTOR_STATUS_ERROR: (state, action) => ({
      ...state,
      isLoading: false,
      error: action.payload,
    }),

    // Backup codes actions
    TWO_FACTOR_BACKUP_CODES_REQUEST: state => ({
      ...state,
      isLoading: true,
      error: null,
    }),
    TWO_FACTOR_BACKUP_CODES_SUCCESS: (state, action) => ({
      ...state,
      isLoading: false,
      error: null,
      backupCodes: action.payload.backupCodes || [],
    }),
    TWO_FACTOR_BACKUP_CODES_ERROR: (state, action) => ({
      ...state,
      isLoading: false,
      error: action.payload,
    }),

    // Clear error
    CLEAR_TWO_FACTOR_ERROR: state => ({
      ...state,
      error: null,
    }),
  },
  initialState,
);

// Selectors
export const getTwoFactorState = state => state.twoFactor || initialState;
export const getTwoFactorStatus = state => getTwoFactorState(state).status;
export const getTwoFactorSetup = state => getTwoFactorState(state).setup;
export const getTwoFactorBackupCodes = state => getTwoFactorState(state).backupCodes;
export const getTwoFactorError = state => getTwoFactorState(state).error;
export const getTwoFactorLoading = state => getTwoFactorState(state).isLoading;

export default TwoFactorReducer;
